import { articleType } from 'src/constants/helpscoutArticles';

export const useHelpScout = (article: articleType, options?: {type: 'modal'}) => window.HelpscoutBeacon.triggerHelpScoutArticle(article, options);

export const useHelpScoutContactForm = () => window.HelpscoutBeacon.triggerHelpScoutScreen('contact-form');

export const useHelpScoutReportForm = ({ name, subject, text }) =>
  window.HelpscoutBeacon.triggerHelpscoutContactForm({name: name, subject: subject, text: text});
